// statsBus.js — aviso ligero para que TopBar (que vive en todas las páginas y
// carga /resumen por sí sola) se refresque cuando algo cambia el número de
// llaves prestadas, sin necesidad de contexto ni de pasar props entre páginas.
const EVENTO = "resumen:cambio";

export function avisarCambioResumen() {
  window.dispatchEvent(new Event(EVENTO));
}

export function onCambioResumen(fn) {
  window.addEventListener(EVENTO, fn);
  return () => window.removeEventListener(EVENTO, fn);
}

// aviso "Actualizar" global (botón de la barra superior): cada panel se
// refresca solo (llamando a su propio cargar()), sin recargar la página
// entera ni perder en qué pestaña/panel está el usuario.
const EVENTO_PANEL = "panel:actualizar";

export function avisarActualizarPanel() {
  window.dispatchEvent(new Event(EVENTO_PANEL));
}

export function onActualizarPanel(fn) {
  window.addEventListener(EVENTO_PANEL, fn);
  return () => window.removeEventListener(EVENTO_PANEL, fn);
}

// Alertas (Administración > 🔔 Alertas): al marcar alguna como vista/correcta,
// la barra superior actualiza su aviso al momento.
const EVENTO_ALERTAS = "alertas:cambio";

export function avisarCambioAlertas() {
  window.dispatchEvent(new Event(EVENTO_ALERTAS));
}

export function onCambioAlertas(fn) {
  window.addEventListener(EVENTO_ALERTAS, fn);
  return () => window.removeEventListener(EVENTO_ALERTAS, fn);
}
